import axios from "axios";

export class LookupDataService {

    getCandidateTypeLookup = () => {
        return axios.get(`api/lookup/candidatetype`);
    };

    getVendorsLookup = (queryStr) => {
        return axios.get(`api/lookup/clientvendors?${queryStr}`);
    }

    getClientsLookup = () => {
        return axios.get(`api/lookup/clients`);
    }
    getDoNotHireReasons = () => {
        return axios.get(`/api/lookup/dnh/reasons`);
    };

    getPublishedScheduleLookup = (id, shiftTypeId) => {
        return axios.get(`api/lookup/schedule/${id}/publishedschedule/${shiftTypeId}`);
    }

    getSuggestedCandidatesLookup = (positionId, startDate, endDate, startTime, endTime, clientId, shiftTypeId, startTimeStr, endTimeStr) => {
        return axios.get(`api/lookup/candidates?positionId=${positionId}&startDate=${startDate}&endDate=${endDate}
        &startTime=${startTime}&endTime=${endTime}&clientId=${clientId}&shiftTypeId=${shiftTypeId}&StartTimeStr=${startTimeStr}&EndTimeStr=${endTimeStr}`);
    }
}

export default new LookupDataService();